export default function (v, o) {
  for (let i = 0; i < o.length; i++) {
    if (o[i].value == v) return o[i]
  }
}
